(function() {
  var app = angular.module('priorWeb');

  app.constant('RedsysStatusEnum', {
    ERROR: 'ERROR',
    OK: 'OK'
  });
})();
